export default __webpack_public_path__ + "static/mission_squiggle-f7aa88b431931b14a0e77851d0ab3e9d.png";